module.exports = __webpack_public_path__ + "img/customers-dd-l2.1ddbc4e8.svg";